import { Link } from 'react-router-dom'

interface LinkProps {
  className?: string
  href: string
  children?: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}
const LinkComps = (props: LinkProps) => {
  const { href, ...rest } = props
  return <Link {...rest} to={href} />
}

export default LinkComps
